module.exports = __webpack_public_path__ + "img/03.01d886b8.png";